<panel width="950">
	<h1>{{ title }}</h1>
	@if (taskflowTemplate) {
		<section scrollable>
			<tags [(selectedTags)]="taskflowTemplate.taskflowTemplateTags" [tags]="taskflowTemplateTags" />
			<custom-input [label]="'taskflow-template.title' | translate" [(value)]="taskflowTemplate.title" [placeholder]="'taskflow-template.title-placeholder' | translate" />
			@if (taskflowTemplate.taskTemplates) {
				<task-templates [taskTemplates]="taskflowTemplate.taskTemplates" [taskTemplateTags]="taskTemplateTags" />
			}
		</section>
		<section>
			<button confirm [active]="canSave()" (click)="saveTaskflowTemplate(taskflowTemplate)">{{ 'general.save' | translate }}</button>
		</section>
	}
</panel>
